import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { object } from "prop-types";

import { updateWatchListEntry } from "../../actions";
import {
  getWatchListEntryById,
  clearWatchListEntries,
} from "../../../watch-list-entry/actions";
import { getNationalities, getCountries } from "../../../../actions";
import UpsertWatchListEntryForm from "../../components/upsert-watch-list-entry-form";
import {
  updateWatchListEntrySelector,
  nationalitiesOptionsSelector,
  countriesOptionsSelector,
  selectUpdateWatchListEntryEuTerroristLoading,
} from "../../selectors";
import { trimFormData } from "../../../../utilities/filters";

const UpdateWatchListEntryPage = (props) => {
  const dispatch = useDispatch();
  const initialValues = useSelector(updateWatchListEntrySelector);
  const nationalities = useSelector(nationalitiesOptionsSelector);
  const countries = useSelector(countriesOptionsSelector);
  const isLoading = useSelector(selectUpdateWatchListEntryEuTerroristLoading);

  useEffect(() => {
    const { id } = props.match.params;
    dispatch(getWatchListEntryById({ id, take: 1 }));
    dispatch(getNationalities());
    dispatch(getCountries());

    return () => {
      dispatch(clearWatchListEntries());
    };
  }, []);

  const handleSubmit = (data) => {
    const { id } = props.match.params;
    const trimmedData = trimFormData(data);
    dispatch(updateWatchListEntry({ ...trimmedData, id }));
  };

  return initialValues ? (
    <UpsertWatchListEntryForm
      title="Update EU Terrorist watchlist entry"
      handleSubmit={handleSubmit}
      countries={countries}
      nationalities={nationalities}
      initialValues={initialValues}
      disabledEntryTypeSelection
      isLoading={isLoading}
    />
  ) : (
    <React.Fragment />
  );
};

UpdateWatchListEntryPage.propTypes = {
  match: object.isRequired,
};

export default UpdateWatchListEntryPage;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/pages/update-watch-list-entry-page/UpdateWatchListEntryPage.jsx